import {CountryPanelFormData} from '../components/CountryPanel/CountryPanel.types';
import {ValueDimension} from '../components/index.constants';
import {CountriesState} from './types';

export const initCountryObject: CountryPanelFormData = {
  name: '',
  businessRegion: '',
  currency: 'EUR',
  repairCostDimension: ValueDimension.PER_MONTH,
  maintenanceCostDimension: ValueDimension.PER_MONTH,
  countryCodes: []
};

export const countriesInitialState: CountriesState = {
  list: null,
  countriesLoading: false,
  currencies: null,
  repairCostDimension: null,
  maintenanceCostDimension: null
};
